import React, { ReactElement, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'

import SkeletonImage from '../SkeletonHelpers/SkeletonImage'
import SkeletonTexts from '../SkeletonHelpers/SkeletonTexts'
import { TestID } from '../../utils/PropTypesDefinitions'

export type MidTeaserSkeletonProps = {
    width?: number
} & TestID

const MidTeaserSkeleton = ({ width = 290, testID }: MidTeaserSkeletonProps): ReactElement => {
    const skeletonImageHeight = Math.round(width / (16 / 9))
    return (
        <Grid width={width} testID={testID} backgroundColor="pearl">
            <SkeletonImage height={skeletonImageHeight} />
            <Grid noExpand marginTop={5} height={65}>
                <SkeletonTexts />
            </Grid>
        </Grid>
    )
}

export default memo(MidTeaserSkeleton)
